var _a;
import { AuthClient, GatewayConfiguration } from '@contentsquare/uxanalytics-client';
import { AppContext } from '../models/app.context';
import { Token } from '../models/token';
import { ClientFactory } from './app.client.factory';
import { LocalStorageTokenStorage, UrlExchangeTokenStorage, } from './app.context/app.context.services';
import { ConfigService } from './config.service';
export var AppInitResult;
(function (AppInitResult) {
    AppInitResult[AppInitResult["Success"] = 0] = "Success";
    AppInitResult[AppInitResult["TokenNotAvailable"] = 1] = "TokenNotAvailable";
})(AppInitResult || (AppInitResult = {}));
const FIELD_KEY = '__hls#context';
const wnd = typeof window !== 'undefined' ? window : global;
wnd[FIELD_KEY] = (_a = wnd[FIELD_KEY]) !== null && _a !== void 0 ? _a : {};
export class AppContextFactory {
    static get fields() {
        return wnd[FIELD_KEY];
    }
    static get config() {
        return this.fields.config;
    }
    static isReady() {
        return !!this.fields.context;
    }
    static get() {
        if (!this.fields.context) {
            throw new Error('Context not initialized.');
        }
        return this.fields.context;
    }
    static async loadContext(ctx) {
        if (ctx instanceof AppContext) {
            return this.loadContextSync(ctx);
        }
        else {
            return this.loadContextAsync(ctx);
        }
    }
    static async init(projectId, tokenStorage = LocalStorageTokenStorage, exchangeTokenStorage = UrlExchangeTokenStorage, configService = new ConfigService(), resources) {
        let token;
        this.fields.config = await configService.load();
        const exchangeToken = exchangeTokenStorage.getExchangeToken();
        if (exchangeToken) {
            const authClient = new AuthClient(AppContextFactory.newGatewayConfiguration(this.fields.config.apiUrl));
            const { jwtToken } = await authClient.exchangeToken(exchangeToken);
            token = new Token(jwtToken);
        }
        else {
            const jwt = tokenStorage.getJwt();
            token = jwt && new Token(jwt);
            if (token && token.body.exp < new Date()) {
                token = null;
            }
        }
        if (!token) {
            return AppInitResult.TokenNotAvailable;
        }
        tokenStorage.storeJwt(token.jwt);
        ClientFactory.init(AppContextFactory.newGatewayConfiguration(this.fields.config.apiUrl, token.jwt));
        this.fields.context = await AppContext.build(projectId, this.fields.config, token, resources);
        return AppInitResult.Success;
    }
    static loadContextSync(ctx) {
        const params = [ctx.permissions, ctx.config, ctx.projectId, AppContext.getToken(ctx), ctx.userId];
        if (params.some((i) => !i)) {
            throw new Error('AppContext not properly initialized');
        }
        this.fields.context = ctx;
        this.fields.config = ctx.config;
        ClientFactory.init(AppContextFactory.newGatewayConfiguration(ctx.config.apiUrl, AppContext.getToken(ctx).jwt));
        console.log('AppContext loaded!');
    }
    static getRequestFromProvider() {
        return 'app-frontends';
    }
    static getRequestTagsProvider() {
        const global = window;
        return (global && global._httpRequestTags) || {};
    }
    static getRequestIdProvider() {
        return AppContextFactory.uuid();
    }
    static newGatewayConfiguration(apiUrl, jwtToken) {
        return new GatewayConfiguration(apiUrl, jwtToken, undefined, undefined, AppContextFactory.getRequestIdProvider, AppContextFactory.getRequestFromProvider, AppContextFactory.getRequestTagsProvider);
    }
    static uuid() {
        // tslint:disable: no-bitwise one-variable-per-declaration
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    static async loadContextAsync(state) {
        this.fields.config = state.config;
        const token = state.jwtToken && new Token(state.jwtToken);
        ClientFactory.init(this.fields.config.apiUrl, token.jwt);
        this.fields.context = await AppContext.build(state.projectId, this.fields.config, token, state.resources);
        console.log('AppContext loaded!');
        return this.fields.context;
    }
}
//# sourceMappingURL=app.context.factory.js.map